
    <!--Footer-->
    <footer id="sticky-footer" style="background-color:#041e42;padding-top: 0em;padding-bottom: 0em;" class="py-1 text-white-50">
        <div class="container text-center">
          <small>eCompliance Version 1.3.0</small>
        </div>
      </footer>